// exports rad2deg, deg2rad, parseFloatOr, Magnitude

let r2d = 360.0 / ( 2.0 * Math.PI );
let d2r = 1.0 / r2d;

export function rad2deg(radians) {
  return radians * r2d;
}

export function deg2rad(degrees) {
  return degrees * d2r;
}

export function clamp(n, min, max) {
  return n > max ? max : n < min ? min : n;
}

export function sign(x) {
  return x < 0.0 ? -1 : 1;
}

// Magnitude utilities

export function parseFloatOr(s,d) {
  let v = parseFloat(s);
  return isNaN(v) ? d : v;
}

export const Magnitude = function(value, type ) {
  if( type === undefined ) {
    type = 'mm';
  }
  this.value = value;
  this.type  = type;
};

Magnitude.prototype = {
  toString() {
    return this.value.toFixed(4).concat(( this.type === '%')?'%':'');
  },
  toXmlString() { return this.toString(); },
  isAbsolute() {
    return this.type !== '%';
  },
  absoluteMMValueFor( reference) {
    const { value } = this;
    return this.type === '%' ? ( value * reference / 100 ) : this.toMM() ;
  },
  toMM(aDPI = 25.4) {
    if (this.type === '%') { return this.value;               } 
    if (this.type === 'mm'){ return this.value;               } 
    if (this.type === 'cm'){ return this.value * 10;          } 
    if (this.type === 'in'){ return this.value * 25.4;        } 
    if (this.type === 'pc'){ return this.value * 25.4 / 6;    } 
    if (this.type === 'pt'){ return this.value * 25.4 / 72;   } 
    if (this.type === 'px'){ return this.value * 25.4 / aDPI; }
    return this.value;
  },
  toType(aToType, aDPI = 25.4) { return Magnitude.fromMM(this.toMM(), aToType, aDPI); },
  valueOf() { return this.toMM(); },
  
};

Magnitude.absoluteMMValueFor = function( aValue, reference ) {
  if (!(aValue instanceof Magnitude))
    aValue = Magnitude.parse(aValue);
  return aValue.absoluteMMValueFor(reference);
}

Magnitude.fromMM = function(aValue, aToType, aDPI = 25.4) {
  if (aToType === '%') { return aValue;               } 
  if (aToType === 'mm'){ return aValue;               } 
  if (aToType === 'cm'){ return aValue / 10;          } 
  if (aToType === 'in'){ return aValue / 25.4;        } 
  if (aToType === 'pc'){ return aValue / 25.4 * 6;    } 
  if (aToType === 'pt'){ return aValue / 25.4 * 72;   } 
  if (aToType === 'px'){ return aValue / 25.4 * aDPI; }
  return aValue;
}


Magnitude._defaultType = 'mm';

Magnitude.setDefaultType = function( aType ) {
  const lTypes = ['mm', 'in', 'px', 'pc', 'pt', 'cm', '%'];
  if (lTypes.indexOf(aType) !== -1) {
    Magnitude._defaultType = aType;
  }
  else {
    Magnitude._defaultType = 'mm';
  }
}

Magnitude.parse = function( aXmlString ) {
  if (aXmlString) {

    aXmlString = aXmlString.toString().trim();

    const lastChar = aXmlString.length>0?aXmlString[aXmlString.length - 1]:'';

    if( lastChar === '%' || lastChar === 'r' ) { // 'r' is URL friendly
      const value = parseFloatOr( aXmlString.substring(0,aXmlString.length-1), 0.0 );
      return new Magnitude( value, '%') ;
    }
  
    const lTypes = ['mm', 'in', 'px', 'pc', 'pt', 'cm'];

    for( let i = 0; i < lTypes.length; ++i) {
      let lType = lTypes[i];
      let idx = aXmlString.lastIndexOf(lType);
      if( idx !== -1 ) {
        return new Magnitude(parseFloat(aXmlString.substring(0,idx)), lType);
      }  
    }
      
    return new Magnitude( parseFloatOr(aXmlString,0.0), Magnitude._defaultType ) ;
  }

  return null;

};



/** WEBPACK FOOTER **
 ** ./src/gear/math.js
 **/